import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminLoginExchange } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const me = await adminLoginExchange(sessionId);
        // Strip the session_id from the URL before navigating
        window.history.replaceState({}, document.title, "/admin");
        toast.success(`Welcome back, ${me.name || me.email}`);
        navigate("/admin", { replace: true, state: { user: me } });
      } catch (err) {
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail;
        let msg;
        if (status === 403) {
          msg =
            (typeof detail === "string" && detail) ||
            "This Google account is not authorized as admin.";
        } else if (status === 404) {
          msg =
            "Admin endpoints not deployed yet. Re-deploy via Emergent dashboard.";
        } else if (status === 401) {
          msg =
            (typeof detail === "string" && detail) ||
            "Invalid session. Try signing in again.";
        } else if (status === 502) {
          msg = "Auth provider unreachable. Try again in a minute.";
        } else if (!status) {
          msg =
            "Network error reaching the backend. Confirm the latest build is deployed.";
        } else {
          msg =
            typeof detail === "string"
              ? detail
              : `Sign-in failed (HTTP ${status}). Try again.`;
        }
        toast.error(msg, { duration: 8000 });
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="bg-[#050505] min-h-screen flex items-center justify-center text-white">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#D10000] mx-auto mb-4" />
        <div className="font-display tracking-widest uppercase text-sm text-white/60">
          Verifying credentials…
        </div>
      </div>
    </div>
  );
}
